import { createContext } from 'react';
import { AuthState } from 'src/types/auth-state';

export const AuthContext = createContext<AuthState>({} as AuthState);
